import { Component, Injector, OnInit } from "@angular/core"
import { NavigationEnd, Router } from "@angular/router"
import { MenuService } from "@app/core/menu/menu.service"
import { SettingsService } from "@app/core/settings/settings.service"
import { Intercom } from "ng-intercom"
declare var $: any
import * as _ from "lodash"
declare var window: any
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
})
export class SidebarComponent implements OnInit {
  menuItems: Array<any>
  router: Router
  appCurrentVersion: any
  public parent_account_id: string
  /** Which parent submenu keys are expanded (by item.text) */
  private openSubmenus: { [key: string]: boolean } = {}

  constructor(
    private menu: MenuService,
    public settings: SettingsService,
    private injector: Injector,
    public intercom: Intercom
  ) {
    this.menuItems = menu.getMenu()
    if (localStorage.getItem("appVersion") == "portal") {
      _.remove(this.menuItems, {
        link: "/dashboard",
      })
    }
    // Hide Superadmin menu for non-superadmin users
    if (localStorage.getItem("is_superadmin") !== "1") {
      _.remove(this.menuItems, { text: "Superadmin" })
    }
  }

  ngOnInit() {
    const account = JSON.parse(localStorage.getItem("account"))
    if (account) {
      this.parent_account_id = account.parent_account_id
    }

    this.router = this.injector.get(Router)
    this.appCurrentVersion = localStorage.getItem("appVersion")
    // Keep Superadmin (and any path-based submenu) open when deep-linked
    this.expandActiveSubmenus(this.router.url)
    this.router.events.subscribe(val => {
      // scroll view to top
      window.scrollTo(0, 0)
      if (val instanceof NavigationEnd) {
        this.expandActiveSubmenus(
          val.urlAfterRedirects || val.url || this.router.url
        )
      }
    })
  }

  isActiveRoute(link: string): boolean {
    if (!link || !this.router) return false
    // Strip query/hash — router.url may be "/superadmin?tab=x" or "/leads?page=0"
    const raw = this.router.url || ""
    const url = raw.split("?")[0].split("#")[0]
    if (url === link) return true
    // Exact parent hubs: "/superadmin" should match "/superadmin/groups"
    if (link !== "/" && url.startsWith(link + "/")) return true
    return false
  }

  isSubmenuOpen(item: any): boolean {
    if (!item) return false
    const key = item.text || item.link || ""
    if (this.openSubmenus[key]) return true
    // Also open when parent link or any child is the active route
    if (item.link && this.isActiveRoute(item.link)) return true
    if (item.submenu && Array.isArray(item.submenu)) {
      return item.submenu.some((sub: any) => this.isActiveRoute(sub.link))
    }
    return false
  }

  toggleSubmenu(event: Event, item: any) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    const key = item.text || item.link || ""
    // Explicit toggle independent of route-match auto-open
    const routeOpen =
      item.submenu &&
      Array.isArray(item.submenu) &&
      item.submenu.some((sub: any) => this.isActiveRoute(sub.link))
    const currently = !!this.openSubmenus[key] || routeOpen
    this.openSubmenus[key] = !currently
  }

  /** Parent label click navigates to hub and keeps children visible. */
  ensureSubmenuOpen(item: any) {
    const key = item.text || item.link || ""
    this.openSubmenus[key] = true
  }

  private expandActiveSubmenus(url: string) {
    if (!this.menuItems) return
    const path = (url || "").split("?")[0].split("#")[0]
    this.menuItems.forEach(item => {
      if (!item.submenu || !item.submenu.length) return
      const match = item.submenu.some(
        (sub: any) =>
          sub.link && (path === sub.link || path.startsWith(sub.link + "/"))
      )
      // Also match parent link (/superadmin)
      const parentMatch =
        item.link &&
        (path === item.link || path.startsWith(item.link + "/"))
      if (match || parentMatch) {
        this.openSubmenus[item.text || item.link || ""] = true
      }
    })
  }

  removeFloatingNav() {
    $(".nav-floating").remove()
  }

  isSidebarCollapsed() {
    return this.settings.layout.isCollapsed
  }
  isSidebarCollapsedText() {
    return this.settings.layout.isCollapsedText
  }
  isEnabledHover() {
    return this.settings.layout.asideHover
  }

  showIntercom() {
    this.intercom.show()
  }
}
